import { LocalizationModel } from '@shared/core';
import { IBaseResponseModel, IBaseValueModel } from './base.model';

export interface IBenefitModel {
  active: boolean;
  currentUsesCount: number;
  discountPercent: number;
  name: LocalizationModel;
  periods: [
    {
      start: 0;
      end: 46800;
      dayOfWeeks: [1, 2, 3, 4, 5, 6, 7];
      days: [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30];
    },
  ];
  uuid: IBaseValueModel;
}

export interface IBenefitGrantsResponseModel extends IBaseResponseModel {
  grants: IBenefitGrantsModel[];
}

export interface IBenefitGrantsFilterModel {
  status?: BenefitGrantStatus;
  benefit_uuids: string[];
  limit?: number;
  offset?: number;
  vrps?: string[];
}

export interface IBenefitGrantsModel {
  start?: string;
  end?: string;
  vrp?: string;
  uuid?: IBaseValueModel;
  benefit_uuid?: IBaseValueModel;
  benefit?: IBenefitModel;
  status?: string;
  is_forever?: boolean;
  isDeleted?: boolean;
}

export type IBenefitFilterModel = {
  limit: number;
};

export enum BenefitGrantStatus {
  STATUS_UNSPECIFIED = 0,
  STATUS_FUTURE = 1,
  STATUS_PAST = 2,
  STATUS_CURRENT = 3,
  STATUS_ALL = 4,
}

export type BenefitGrantStatusTranslation = {
  [K in string]: BenefitGrantStatus;
};
export const BENEFIT_GRANT_STATUS_TRANSLATIONS: BenefitGrantStatusTranslation = {
  'Не указан': 0,
  Будущий: 1,
  Прошедший: 2,
  Активный: 3,
  Все: 4,
};

export interface IBenefitStatementResponseModel extends IBaseResponseModel {
  requests: IBenefitStatement[];
}

export interface IBenefitStatement {
  uuid: string;
  number: string;
  fullName: string;
  benefitUuid: string;
  benefitName: string;
  vrp: string;
  zone: string;
  status: StatementStatusType;
  comment: string;
  identityFrontUuid: string;
  identityBackUuid: string;
  techPassFrontUuid: string;
  techPassBackUuid: string;
  statementUuid: string;
  doc1Uuid: string;
  doc2Uuid: string;
  doc3Uuid: string;
  createdAt: string;
  updatedAt: string;
  deleted: boolean;
  isForever: boolean;
  email: string;
}

export enum StatementStatusType {
  New = 'NEW',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
}

export const StatementStatusTypeLabels: Record<StatementStatusType, string> = {
  [StatementStatusType.New]: 'ADMIN_BENEFIT_STATEMENT_STATUS_NEW',
  [StatementStatusType.Approved]: 'ADMIN_BENEFIT_STATEMENT_STATUS_APPROVED',
  [StatementStatusType.Rejected]: 'ADMIN_BENEFIT_STATEMENT_STATUS_REJECTED',
};

export interface IBenefitStatementPayload {
  request_uuid: string;
  vrp: string;
  start?: string;
  end?: string;
  is_forever: boolean;
  reason: string;
}

export interface IBenefitStatementFilterModel {
  page_index?: number;
  page_size?: number;
  date_from?: number;
  date_to?: number;
  query?: string;
}

export interface IBenefitGrantImportPayload {
  benefit_uuid: string;
  file_content: string;
}

export interface IBenefitGrantImportResponse {
  errors?: string[];
  errorCount?: number;
}
